import { AutomationStep } from '@/types/automationSteps.ts';
import { useMemo } from 'react';
import useIsNewStep from '@/hooks/useIsNewStep.ts';

const useStepErrors = (step?: AutomationStep) => {
  const isNewStep = useIsNewStep(step?.step_id);

  return useMemo(() => {
    if (!step || isNewStep) {
      return [];
    }
    return step.errors || [];
    // const collectErrors = (currentStep: AutomationStep): StepError[] => {
    //   let currentErrors = currentStep.errors || [];
    //
    //   // Only recurse if 'children' actually exists
    //   if ('children' in currentStep && Array.isArray(currentStep.children)) {
    //     for (const child of currentStep.children) {
    //       currentErrors = currentErrors.concat(collectErrors(child));
    //     }
    //   }
    //
    //   return currentErrors;
    // };
    //
    // return collectErrors(step);
  }, [isNewStep, step]);
};

export default useStepErrors;
